module["exports"] = [];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/address/state_abbr.js
 ** module id = 1021
 ** module chunks = 0
 **/